export default __webpack_public_path__ + "static/media/dash-access-science.b61035ac.svg";